const loadPageStrip = callback => {
  const hasScript = document.getElementById('pagestrip');
  if (!hasScript) {
    const scr = document.createElement('script');
    scr.src = '//js.pagestrip.com/loader.min.js';
    scr.id = 'pagestrip';
    document.body.appendChild(scr);
    scr.onload = () => callback();
  } else if (callback) {
    callback();
  }
};

export default loadPageStrip;
